module.exports = __webpack_public_path__ + "static/media/konf-room-3.99d26b83.jpg";